import { render, staticRenderFns } from "./ApproveCommand.vue?vue&type=template&id=462374f0&scoped=true&"
import script from "./ApproveCommand.vue?vue&type=script&lang=ts&"
export * from "./ApproveCommand.vue?vue&type=script&lang=ts&"
import style0 from "./ApproveCommand.vue?vue&type=style&index=0&id=462374f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462374f0",
  null
  
)

export default component.exports